module.exports = "<vb-generic-form-group\r\n  [label]=\"'Lager'\"\r\n  [helpText]=\"'Das Lager, in welchem die Inventur durchgeführt wird'\"\r\n  [inputId]=\"'depotInput'\"\r\n  [control]=\"control?.get('depot_id')\">\r\n  <vb-depot-selection\r\n    id=\"depotInput\"\r\n    [control]=\"control?.get('depot_id')\"\r\n    [selectedDepotCuid]=\"item?.depot?.cuid\">\r\n  </vb-depot-selection>\r\n</vb-generic-form-group>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/stocktaking/components/depot-stocktaking-form/depot-stocktaking.component.html
// module id = ./src/app/store-management/stocktaking/components/depot-stocktaking-form/depot-stocktaking.component.html
// module chunks = main